import { supabase } from "../supabase/SupabaseClient";

/* Permisos: qué puede ver y hacer cada uno.
 *
 * Todo pasa por funciones de la base que verifican del lado del servidor. La
 * pantalla decide qué DIBUJAR; quién puede de verdad lo decide Supabase. Si
 * sólo se controlara acá, cualquiera podría hablarle a la base directo y
 * saltearse la pantalla entera.
 */

export async function misPermisos() {
  try {
    const { data, error } = await supabase.rpc("mis_permisos");
    if (error) {
      console.warn("[permisos] no se pudieron leer:", error.message);
      return [];
    }
    return data || [];
  } catch (e) {
    return [];
  }
}

export async function permisosDeTodos() {
  const { data, error } = await supabase.rpc("permisos_de_todos");
  if (error) throw error;
  return data;
}

export async function cambiarPermiso(mail, permiso, dar) {
  const { error } = await supabase.rpc("cambiar_permiso", {
    p_mail: mail,
    p_permiso: permiso,
    p_dar: dar,
  });
  if (error) throw error;
}

/* Varios permisos a varias personas, en una sola llamada.
 *
 * Antes la pantalla hacía un bucle con una llamada por permiso. Además de ser
 * N viajes de red para una sola decisión, si el quinto fallaba quedaban cuatro
 * aplicados y ninguna forma de saber cuáles. Del lado de la base esto es una
 * transacción: o se aplican todos o no se aplica ninguno.
 */
export async function cambiarPermisosLote(mails, permisos, dar) {
  const { data, error } = await supabase.rpc("cambiar_permisos_lote", {
    p_mails: mails,
    p_permisos: permisos,
    p_dar: dar,
  });
  if (error) throw error;
  return data;
}

/* Copiar lo que tiene una persona a otras. SUMA, no reemplaza: reemplazar
 * borraría ajustes hechos a mano de un solo click, y eso no se puede deshacer
 * sin acordarse de qué tenía cada uno. */
export async function copiarPermisos(desde, hacia) {
  const { data, error } = await supabase.rpc("copiar_permisos", {
    p_desde: desde,
    p_hacia: hacia,
  });
  if (error) throw error;
  return data;
}

/* ── La baja de una cuenta del hub (05/10) ─────────────────────────────────
 *
 * Antes no había: se le sacaban los permisos y la cuenta seguía entrando a
 * las pantallas que no piden ninguno. La baja la hace la base
 * (`dar_de_baja_cuenta`): guarda quién, cuándo y por qué, le corta la clave
 * en Supabase Auth y apaga todas sus llaves. Pide `admin.permisos` y no deja
 * darse de baja a uno mismo. Reactivar la devuelve con lo que tenía. */
export async function darDeBajaCuenta(mail, motivo) {
  const { error } = await supabase.rpc("dar_de_baja_cuenta", {
    p_mail: mail,
    p_motivo: motivo,
  });
  if (error) throw error;
}

export async function reactivarCuenta(mail) {
  const { error } = await supabase.rpc("reactivar_cuenta", { p_mail: mail });
  if (error) throw error;
}

/* ¿La sesión que está mirando es de una cuenta dada de baja? Ante la duda
 * (falla la consulta) contesta que no: el corte de verdad lo hacen la base y
 * Supabase Auth, y esto es lo que se le MUESTRA a la persona. Bloquear el hub
 * entero a todos por un error de red sería peor que mostrarle de más a una
 * cuenta que igual no puede leer nada con permiso. */
export async function miCuentaDeBaja() {
  try {
    const { data, error } = await supabase.rpc("mi_cuenta_de_baja");
    if (error) return false;
    return data === true;
  } catch (e) {
    return false;
  }
}
